import React from 'react'
import ServiceItem from './index';

const ServiceItemCollection = ({data}) => {
    if(!Array.isArray(data) || (Array.isArray(data) && data.length < 1)){
        return null;
    }
  return (
    <>
        {
            data.map((item, i)=>{
                return(
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6" key={i}>
                    <ServiceItem image={item.image} title={item.title} comment={item.comment} ButtonTitle={item.ButtonTitle} url={item.url}/>
                    </div>
                )
            })
        }
    </>
  )
}

export default ServiceItemCollection